/**
 * Loads an image from the given source.
 *
 * @param {String} src - The URL of the image to load.
 * @return {Promise<Image>} - A promise that resolves with the Image object if the image loads successfully, or rejects if the image does not exist or there is an error.
 */
export function loadSrc(src) {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () => {
            resolve(img);
        };
        img.onerror = () => {
            reject();
        };
        img.src = src;
    });
}
